<div #maincontainer class="address-book-container scroll-container">

  <!-- Loading bar (top fixed) -->
  <mat-progress-bar *ngIf="isLoadingMoreRecords" mode="indeterminate" class="top-progress-bar"></mat-progress-bar>

  <!-- Desktop header -->
  <div class="header-bar desktop-header">
    <div class="header-items">
      <div class="header-select-all" *ngIf="!_authService.readOnly">
        <mat-checkbox color="accent" (change)="selectAllItems($event)">Select All</mat-checkbox>
      </div>

      <mat-form-field class="header-sort-by" appearance="fill">
        <mat-label>Sort By</mat-label>
        <mat-select [(ngModel)]="listSearchData.sortBy" (selectionChange)="filterChanged('sortBy')">
          <mat-option *ngFor="let sort of sortByLookup" [value]="sort.id">{{ sort.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-icon-button (click)="filterChanged('sortOrder')" matTooltip="sort direction" matTooltipPosition="below">
        <mat-icon>{{ sortOrderIcon }}</mat-icon>
      </button>

      <mat-form-field class="header-search" appearance="fill">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="listSearchData.filterString" (keyup.enter)="filterChanged('sortBy')">
      </mat-form-field>

      <button mat-icon-button (click)="filterChanged('clear')" matTooltip="clear search" matTooltipPosition="below">
        <mat-icon>clear</mat-icon>
      </button>

      <span class="spacer"></span>

      <div class="header-actions" *ngIf="!_authService.readOnly">
        <button mat-icon-button *ngIf="anyItemSelected()" (click)="openModal()" matTooltip="delete" matTooltipPosition="below">
          <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button [routerLink]="['/addressbook', 0]" matTooltip="add new company" matTooltipPosition="below">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile header -->
  <div class="header-bar mobile-header">
    <div class="mobile-header-row">
      <div class="header-select-all" *ngIf="!_authService.readOnly">
        <mat-checkbox color="accent" (change)="selectAllItems($event)">Select All</mat-checkbox>
      </div>
      <span class="spacer"></span>
      <div class="header-actions" *ngIf="!_authService.readOnly">
        <button mat-icon-button (click)="showMobileFilters = !showMobileFilters" matTooltip="expand search" matTooltipPosition="below">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button *ngIf="anyItemSelected()" (click)="openModal()" matTooltip="delete" matTooltipPosition="below">
          <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button [routerLink]="['/addressbook', 0]" matTooltip="add new company" matTooltipPosition="below">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    <div class="mobile-filters" *ngIf="showMobileFilters">
      <mat-form-field class="mobile-sort-by" appearance="fill">
        <mat-label>Sort By</mat-label>
        <mat-select [(ngModel)]="listSearchData.sortBy" (selectionChange)="filterChanged('sortBy')">
          <mat-option *ngFor="let sort of sortByLookup" [value]="sort.id">{{ sort.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-icon-button (click)="filterChanged('sortOrder')" matTooltip="sort direction" matTooltipPosition="below">
        <mat-icon>{{ sortOrderIcon }}</mat-icon>
      </button>

      <mat-form-field class="mobile-search" appearance="fill">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="listSearchData.filterString" (keyup.enter)="filterChanged('sortBy')">
      </mat-form-field>

      <button mat-icon-button (click)="filterChanged('clear')" matTooltip="clear search" matTooltipPosition="below">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <!-- No results / empty or error -->
  <div *ngIf="itemList.length <= 0" class="no-results">
    <mat-icon class="no-results-icon" [class.is-error]="inErrorState">{{ inErrorState ? 'error' : 'info_outline' }}</mat-icon>
    <span>{{ searchMessage }}</span>
  </div>

  <!-- Contact cards grid -->
  <div class="cards-grid">
    <mat-card *ngFor="let item of itemList" class="contact-card">
      <mat-card-content>
        <div class="card-row">
          <div class="initial">
            {{ (item.name || '?').toUpperCase().substring(0, 1) }}
          </div>
          <div #contactCard class="card-details" (click)="showCompanyDetail(item.id)">
            <div class="company-name">{{ item.name }}</div>
            <div *ngIf="item.defaultContact && item.defaultContact.name" class="contact-name">
              {{ item.defaultContact.name }}
            </div>
            <div *ngIf="!item.defaultContact || !item.defaultContact.name" class="contact-name">
              {{ item.contacts && item.contacts.length > 0 ? (item.contacts[0].name ? item.contacts[0].name : '&nbsp;') : '&nbsp;' }}
            </div>
            <div class="email">
              <mat-icon>email</mat-icon>
              <span>{{ item.defaultContact ? item.defaultContact.email : (item.contacts.length > 0 ? item.contacts[0].email : '') }}</span>
            </div>
            <div class="phone">
              <mat-icon>call</mat-icon>
              <span>{{ item.defaultContact ? item.defaultContact.phoneNumber || item.defaultContact.phoneNumber2 || item.defaultContact.phoneNumber3 : (item.contacts.length > 0 ? item.contacts[0].phoneNumber || item.contacts[0].phoneNumber2 || item.contacts[0].phoneNumber3 : '') }}</span>
            </div>
          </div>
          <div class="card-select" *ngIf="!_authService.readOnly">
            <mat-checkbox color="accent" [(ngModel)]="item.isSelected" (click)="stopPropagation($event)"></mat-checkbox>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <a *ngIf="!_authService.readOnly"
           href="mailto:{{ item.defaultContact ? item.defaultContact.email : (item.contacts.length > 0 ? item.contacts[0].email : '') }}">
          <mat-icon [ngClass]="{'disabled-icon': !item.defaultContact || !item.defaultContact.email}">email</mat-icon>
        </a>
        <span *ngIf="_authService.readOnly"></span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="CopyClipboard(contactCard)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <!-- Loading more indicator -->
  <div *ngIf="isLoadingMoreRecords" class="loading-more">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <h4>Loading More Items...</h4>
  </div>
</div>

<!-- Load More FAB -->
<button mat-fab class="fab-load-more"
        [disabled]="!moreRecords()"
        (click)="manualLoad()"
        matTooltip="load more..." matTooltipPosition="above">
  <mat-icon>expand_more</mat-icon>
</button>

<!-- Add New Company FAB -->
<button mat-fab color="accent" class="fab-new-company"
        *ngIf="!_authService.readOnly"
        [routerLink]="['/addressbook', 0]"
        matTooltip="add new company" matTooltipPosition="above">
  <mat-icon>add</mat-icon>
</button>
